


















import Vue from 'vue'

import { Modals } from '@/constants/modals'
import Payment from '@/components/Billing/Payment/Payment.vue'
import { ModalParams, EModalStep } from '@/models/billing'
import Close from '@/assets/svg/rounded/close.svg?inline'

interface Data {
  modalName: Modals
  modalSetting: ModalParams
}

interface Methods {
  beforeOpenModal: (params: { params: ModalParams }) => void
}

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    Payment,
    Close,
  },
  data() {
    return {
      modalName: Modals.PaymentModal,
      modalSetting: {
        modalStep: EModalStep.tariffs,
        enableMonths: true,
        enableUsers: true,
        userCount: 1,
      },
    }
  },
  methods: {
    beforeOpenModal(params) {
      this.modalSetting = params.params
    },
  },
})
